import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import TextField from 'components/TextField'
import SearchField from 'components/SearchField'
import Button from 'components/buttons/Button'
import PageControl from 'components/PageControl'

import Modal from 'components/Modal'

import SectionWithHeader from 'layout/SectionWithHeader'

import BreakReportList from 'lists/BreakReportList'

import ReportsAPI from 'api/ReportsAPI'


import styles from './index.css'

@withRouter
export default class Break extends React.Component {
  
  static propTypes = {
  }

  pageSize = 25

  state = {
    modal : null,
    reports: [],
    total: 0,
    page : 1,
    skip: 0,
    limit: this.pageSize
  }

  async fetchReports({ search, skip, limit }) {
    this.setState({ loading: true })
    const {response} = await ReportsAPI.listBreakReports({
      search, skip, limit
    })
    if (response) {
      this.setState({ 
        total : response.total,
        reports: response.results 
      })
    }
    this.setState({ loading: false })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.fetchReports({
        skip: (this.state.page-1) * this.pageSize,
        limit: this.pageSize
      })
    }
  }

  componentDidMount() {
    this.fetchReports(this.state)
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <BreakReportList 
        loading={this.state.loading}
        entities={this.state.reports}
        pageControl={
          <PageControl 
            page={this.state.page}
            numPages={Math.ceil(this.state.total / this.pageSize)}
            onChange={page => this.setState({ page }) } />
        }
        />
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Reports/Break/index.jsx